import { Button, Col, Layout, Row, Spin } from 'antd'
import { t } from 'i18next'
import React, { useEffect, useState } from 'react'
import { Link, Outlet, useParams } from 'react-router-dom'
import { Color } from '../../Common/Color'
import { get } from '../../Common/api'
import { LeftOutlined } from '@ant-design/icons'
import GepetoTabs from './GepetoTabs'

const { _Header, Content } = Layout

export default function GepetoPage () {
  const { id } = useParams()
  const [loading, setLoading] = useState(false)
  const [gepeto, setGepeto] = useState(null)

  const loadGepeto = async () => {
    setLoading(true)
    await get({
      url: `admin/gepetos/${id}`,
      params: {},
      onSuccess: (json) => {
        setLoading(false)
        setGepeto(json)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  useEffect(() => {
    loadGepeto()
  }, [])

  return (
    <>
      <Spin spinning={loading}> <Outlet /> </Spin>
      <Layout style={{ padding: '1em 0', color: Color.dark_blue, fontSize: '24px' }}>
        <Row >
          <Col>
            <Link to={'/admin/gepetos'}><Button type="text" icon={<LeftOutlined />} /></Link>
          </Col>
          <Col style={{ fontSize: '24px' }}>{gepeto?.box?.name}</Col>
        </Row>
      </Layout>
      <Content>
        <Layout style={{ padding: '1em', backgroundColor: 'white' }}>
          <h2>{t('Admin.GepetoPage.title')}</h2>
          {gepeto && <GepetoTabs gepeto={gepeto} setGepeto={setGepeto} />}
        </Layout>
      </Content>
    </>
  )
}
